import React from 'react';
import {
    Box,
    Paper,
    List,
    ListItem,
    ListItemText,
    Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Use the same container styling as the other components for consistency.
const StyledListContainer = styled(Paper)(({ theme }) => ({
    backgroundColor: '#202020',
    borderRadius: '12px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
}));

// This title component is consistent with the other components.
const SectionTitle = styled(Typography)({
    marginBottom: '1rem',
    color: '#12c099',
    fontWeight: 'bold',
});

// Reusable styled link for a clean look and maintainability.
const StyledLink = styled('a')({
    color: '#12c099',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '1rem',
    '&:hover': {
        textDecoration: 'underline',
    },
});

const Attendees = ({ attendees }) => {
    // Helper function to capitalize the first letter of a string.
    const capitalize = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    return (
        // Wrapper for consistent outer spacing.
        <Box sx={{ mt: 4 }}>
            <SectionTitle variant="h4">Check-Ins</SectionTitle>

            <StyledListContainer>
                <List sx={{ padding: 0 /* Remove default list padding */ }}>
                    {attendees.map((attendee, index) => (
                        <ListItem
                            key={index}
                            sx={{
                                borderBottom: '1px solid #404040',
                                // Consistent hover effect.
                                '&:hover': {
                                    backgroundColor: '#2b2b2b',
                                },
                                // Remove border from the last item.
                                '&:last-child': {
                                    borderBottom: 'none',
                                },
                                // Consistent padding.
                                padding: '16px 20px',
                            }}
                        >
                            <ListItemText
                                primary={
                                    <StyledLink
                                        href={`https://admin.marsreel.com/${attendee.type}/${attendee.firebaseUid}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {attendee.name} ({capitalize(attendee.type)})
                                    </StyledLink>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </StyledListContainer>
        </Box>
    );
};

export default Attendees;